const getHomePageLink = (homePage: string, defaultDashboard: string | null) : string => {
	switch(homePage){
	case "1":
		return defaultDashboard && defaultDashboard !== null ? `/dashboard/${defaultDashboard}` : "/";
	case "2":
		return "/indicators/panel";
	case "3":
		return "/actions/panel";
	case "4":
		return "/actions/matrix" ;
	case "5":
		return "/maps/panel" ;
	case "6":
		return "/actions/kanban";
	case "7":
		return "/projects/panel";
	case "8":
		return "/occurrences/panel";
	case "9":
		return "/financialmanagement/panel";
	case "10":
		return "/audit/panel";
	default: 
		return defaultDashboard && defaultDashboard !== null ? `/dashboard/${defaultDashboard}` : "/";
	}
};
  

export default getHomePageLink;
